// src/modules/app-views/serviceOrders/pages/Init/components/tableColumns/totalColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { DollarOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function totalColumn(buildColumnProps, options = {}) {
  const {
    key = 'grandTotal',
    title = 'grand_total',
    dataIndex = 'grandTotal',
    width = 130,
    align = 'right',
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const total = r?.grandTotal;
      return total ? (
        <span>
          <DollarOutlined style={{ marginRight: 4, color: '#52c41a' }} />
          {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(total)}
        </span>
      ) : (
        '—'
      );
    },
  };
}

export default totalColumn;
